export const footerLinks = {
  usefulLinks: {
    head: "Menu Principal",
    links: ["Inicio", "Sobre nós", "Serviços", "Portfolio", "Contato"],
  },
  servicesLinks: {
    head: "",
    links: [
      
    ],
  },
};
